import { useMutation } from '@tanstack/react-query';
import type { AcceptLegalAgreementsRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchAcceptLegalAgreements } from '../api/acceptLegalAgreements.js';

export interface AcceptLegalAgreementsVariables {
  data: AcceptLegalAgreementsRequestT;
}

export function useAcceptLegalAgreementsMutation() {
  return useMutation({
    mutationKey: ['dosespot-idp', 'accept-legal-agreements'],
    mutationFn: async ({ data }: AcceptLegalAgreementsVariables) => {
      return await fetchAcceptLegalAgreements(data);
    },
  });
}
